import React, { useState } from "react";
import { Menu, X, Phone } from "lucide-react";
import logo from "../assets/otherimages/logobd.png";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <nav className="fixed top-0 left-0 w-full bg-white shadow-md z-50 px-4 lg:px-20">
      <div className="container mx-auto flex items-center justify-between py-3 md:py-4 relative">
        {/* ---------- Mobile + Tablet (<1024px) ---------- */}
        <div className="flex w-full items-center justify-between lg:hidden">
          {/* Hamburger */}
          <button className="text-[#0B2F6B]" onClick={() => setIsOpen(!isOpen)}>
            {isOpen ? <X size={28} /> : <Menu size={28} />}
          </button>

          {/* Logo Center */}
          <img
            src={logo}
            alt="Logo"
            className="h-[3.5rem] w-auto absolute left-1/2 -translate-x-1/2"
          />

          {/* Contact Icon */}
          <a
            href="#contact"
            className="bg-[#0B2F6B] text-white p-2 rounded-lg shadow hover:opacity-90 transition"
          >
            <Phone size={22} />
          </a>
        </div>

        {/* ---------- Desktop (≥1024px) ---------- */}
        <div className="hidden lg:flex items-center justify-between w-full">
          {/* Logo */}
          <img src={logo} alt="Logo" className="h-[4rem] w-auto" loading="lazy"/>

          {/* Center Menu */}
          <ul className="font-semibold flex space-x-8 text-[#0B2F6B]">
            <li>
              <a href="#home" className="hover:opacity-80">
                Home
              </a>
            </li>
            <li>
              <a href="#about" className="hover:opacity-80">
                About Us
              </a>
            </li>
            <li>
              <a href="#cars" className="hover:opacity-80">
                Our Cars
              </a>
            </li>
            <li>
              <a href="#why" className="hover:opacity-80">
                Why You Choose Us
              </a>
            </li>
          </ul>

          {/* Contact Us Button */}
          <a
            href="#contact"
            className="bg-[#0B2F6B] text-white px-5 py-2 rounded-lg font-medium hover:opacity-90 transition"
          >
            Contact Us
          </a>
        </div>
      </div>

      {/* Dropdown for Mobile + Tablet */}
      {isOpen && (
        <div className="lg:hidden bg-white border-t border-gray-200">
          <ul className="flex flex-col items-center py-4 space-y-4 text-[#0B2F6B] font-medium">
            <li>
              <a href="#home" onClick={() => setIsOpen(false)}>
                Home
              </a>
            </li>
            <li>
              <a href="#about" onClick={() => setIsOpen(false)}>
                About Us
              </a>
            </li>
            <li>
              <a href="#cars" onClick={() => setIsOpen(false)}>
                Our Cars
              </a>
            </li>
            <li>
              <a href="#why" onClick={() => setIsOpen(false)}>
                Why You Choose Us
              </a>
            </li>
          </ul>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
